import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AENDERUNGEN, VERSION, type Aenderung } from '../version';

/** "1.2.3" vergleichen: >0 wenn a neuer als b. */
function vergleiche(a: string, b: string): number {
  const pa = a.split('.').map(Number);
  const pb = b.split('.').map(Number);
  for (let i = 0; i < 3; i++) {
    const d = (pa[i] ?? 0) - (pb[i] ?? 0);
    if (d !== 0) return d;
  }
  return 0;
}

const schluessel = (userId: string) => `lwawi_gesehene_version_${userId}`;

const datum = (iso: string) => {
  const [jahr, monat, tag] = iso.split('-');
  return `${tag}.${monat}.${jahr}`;
};

/**
 * Zeigt nach dem Login einmalig, was seit der zuletzt gesehenen Version neu ist.
 * Welche Version ein Benutzer schon gesehen hat, merkt der Browser (pro Benutzer).
 * Beim allerersten Mal wird nur die aktuelle Version gezeigt, nicht die ganze
 * Historie.
 */
export function VersionPopup({ userId }: { userId: string }) {
  const [neu, setNeu] = useState<Aenderung[] | null>(null);

  useEffect(() => {
    let gesehen: string | null = null;
    try {
      gesehen = localStorage.getItem(schluessel(userId));
    } catch {
      gesehen = null;
    }
    if (gesehen === VERSION) return; // nichts Neues

    const zuZeigen = gesehen
      ? AENDERUNGEN.filter((a) => vergleiche(a.nummer, gesehen!) > 0)
      : AENDERUNGEN.slice(0, 1); // erstes Mal: nur die aktuelle Version
    if (zuZeigen.length > 0) setNeu(zuZeigen);
  }, [userId]);

  function schliessen() {
    try {
      localStorage.setItem(schluessel(userId), VERSION);
    } catch {
      /* privater Modus o. Ä. - dann erscheint es beim nächsten Mal erneut */
    }
    setNeu(null);
  }

  if (!neu) return null;

  return (
    <div className="modal-overlay" onClick={schliessen}>
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxHeight: '80vh', overflow: 'auto' }}>
        <h2 style={{ marginTop: 0 }}>Neu in der Logistik-WaWi</h2>
        {neu.map((a) => (
          <div key={a.nummer} style={{ marginBottom: 16 }}>
            <div className="small" style={{ fontWeight: 700, marginBottom: 6 }}>
              Version {a.nummer} · {datum(a.datum)}
            </div>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              {a.punkte.map((p, i) => (
                <li key={i} style={{ marginBottom: 4 }}>{p}</li>
              ))}
            </ul>
          </div>
        ))}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12, gap: 12 }}>
          <Link to="/neuigkeiten" className="small" onClick={schliessen}>
            Alle Versionen ansehen
          </Link>
          <button className="primary" onClick={schliessen}>
            Verstanden
          </button>
        </div>
      </div>
    </div>
  );
}
